import React, { useState } from "react";
import "../SigninResigsterModal/AuthForm.css";
import { registerUser } from "../Utils/index.js";
import { isValidUsername } from "../Utils/isValidUsername.js";
import { isPasswordValid } from "../Utils/isPasswordValid.js";
import "./Register.css";

const Register = ({ setToken, setUserData, setCurrentPage }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");
  const [displayError, setDisplayError] = useState("");
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [isValidPassword, setIsValidPassword] = useState(false);
  const [isValidUsernameB, setIsValidUsername] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handlePassword = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    setIsValidPassword(isPasswordValid(newPassword));
  };

  const handleEmail = (e) => {
    const newEmail = e.target.value.toLowerCase();
    setEmail(newEmail);
    // Validate email: at least one character before @, contains '@', ends with '.xxx'
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    setIsValidEmail(emailRegex.test(newEmail));
  };

  const handleUsername = (e) => {
    const newUsername = e.target.value;
    setUsername(newUsername);
    // Validate username using the imported utility function
    setIsValidUsername(isValidUsername(newUsername));
  };

  const anyFieldHaveStringLength =
    email.length >= 1 || password.length >= 1 || username.length >= 1;

  const handleBlur = () => {
    if (!anyFieldHaveStringLength) {
      setDisplayError("");
    }
    if (!isValidEmail && email.length >= 1) {
      setDisplayError("Email format not correct");
    } else if (!isValidUsernameB && username.length >= 1) {
      // New condition for username
      setDisplayError(
        "Username: start with a letter, _ allowed, 4 - 15 chars, "
      );
    } else if (!isValidPassword && password.length >= 1) {
      setDisplayError(
        "Password: 7 char min, 1 uppercase, 1 lowercase, and 1 number"
      );
    } else {
      setDisplayError("");
    }
  };

  const isAllFielsValid = isValidEmail && isValidPassword && isValidUsername;

  //submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setDisplayError("");
    try {
      const registerError = await registerUser(
        email,
        password,
        username,
        setToken,
        setUserData
      );
      if (registerError) {
        setDisplayError(registerError);
      } else {
        // If no error, clear the displayError
        setDisplayError("");
        setCurrentPage("onboarding");
      }
    } catch (error) {
      console.error("Error registering:", error);
      setDisplayError("An unexpected error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="AuthForm">
      <h2>{"REGISTER"}</h2>
      <form className="auth-form">
        {/* email */}
        <input
          placeholder="Email"
          onChange={handleEmail}
          onBlur={() => handleBlur()}
          type="text"
          value={email}
        />
        {/* username */}
        <input
          style={{ textTransform: "lowercase" }}
          placeholder="Username"
          onChange={handleUsername}
          onBlur={() => handleBlur()}
          type="text"
          value={username}
        />
        {/* password */}
        <div className="passwordDiv">
          <input
            style={{
              width: "100%",
              border: "none",
              margin: "0",
              boxSizing: "border-box",
              padding: ".5px",
            }}
            placeholder="Password"
            onChange={handlePassword}
            onBlur={() => handleBlur()}
            type={showPassword ? "text" : "password"}
            value={password}
          />
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="password-toggle"
          >
            {showPassword ? "Hide" : "Show"}
          </button>
        </div>
        {/* submit button */}
        <p
          style={{
            visibility: displayError === "" ? "hidden" : "visible",
            color: "rgb(154, 0, 0)",
            minHeight: "3rem",
          }}
        >
          <div style={{ maxWidth: "15rem", margin: "auto" }}>
            {displayError}
          </div>
        </p>
        {isAllFielsValid && (
          <button
            onClick={handleSubmit}
            disabled={!isAllFielsValid}
            className="authButton"
            type="submit"
          >
            {isLoading ? <div className="spinner"></div> : "Submit"}{" "}
          </button>
        )}
      </form>
    </div>
  );
};

export default Register;
